@switch (status()) {
  @case (IndicatorStatus.Saving) {
    <ion-spinner
      name="crescent"
      [ngStyle]="{ width: size() + 'px', height: size() + 'px' }"
      class="text-neutral-600 dark:text-neutral-500"
    />
  }
  @case (IndicatorStatus.Saved) {
    <dojo-icon [icon]="'check'" [size]="size()" />
  }
  @case (IndicatorStatus.Error) {
    <dojo-icon [icon]="'times'" [size]="size()" />
  }
  @default {}
}
